function AnalysisIcon({ width = 10, height = 12 }) {
    return (
        <svg width={width} height={height} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66667 0C5.03486 0 5.33333 0.298477 5.33333 0.666667V11.3333C5.33333 11.7015 5.03486 12 4.66667 12C4.29848 12 4 11.7015 4 11.3333V0.666667C4 0.298477 4.29848 0 4.66667 0ZM8.66667 4C9.03486 4 9.33333 4.29848 9.33333 4.66667V11.3333C9.33333 11.7015 9.03486 12 8.66667 12C8.29848 12 8 11.7015 8 11.3333V4.66667C8 4.29848 8.29848 4 8.66667 4ZM0.666667 6.66667C1.03486 6.66667 1.33333 6.96514 1.33333 7.33333V11.3333C1.33333 11.7015 1.03486 12 0.666667 12C0.298477 12 0 11.7015 0 11.3333V7.33333C0 6.96514 0.298477 6.66667 0.666667 6.66667Z" fill="#5D636F" />
        </svg>
    );
}

export default AnalysisIcon;
